export default (url) => (
  !/^https?:\/\//i.test(url) ? `http://${url}` : url
);
